import React from "react";

/**
 * Shared cell styles for the solver tables. Input columns (the variable /
 * constraint indexes) use the normal UI font, while output columns (values the
 * solver produced — value, status, dual, the constraint definition) use a
 * tinted monospace so they read as machine output distinct from the indexes.
 */

const headerBase: React.CSSProperties = {
  textAlign: "left",
  padding: "4px 8px",
  borderBottom: "2px solid #ddd",
  position: "sticky",
  top: 0,
  // Above the scrolling body (incl. the constraint table's sticky dual column).
  zIndex: 2,
  whiteSpace: "nowrap",
};

const cellBase: React.CSSProperties = {
  padding: "2px 8px",
  borderBottom: "1px solid #eee",
  whiteSpace: "nowrap",
};

// Input (index) columns: proportional font.
export const inputHeader: React.CSSProperties = {
  ...headerBase,
  background: "#f8f8f8",
  fontWeight: 600,
  color: "#555",
};

export const inputCell: React.CSSProperties = {
  ...cellBase,
  color: "#333",
};

// Input columns that are themselves expressions (e.g. a constraint's
// definition): styled as an input — no output tint — but monospace since the
// content is code-like.
export const inputMonoHeader: React.CSSProperties = {
  ...inputHeader,
  fontFamily: "monospace",
};

export const inputMonoCell: React.CSSProperties = {
  ...inputCell,
  fontFamily: "monospace",
};

// Output (solver result) columns: tinted monospace.
export const outputHeader: React.CSSProperties = {
  ...headerBase,
  background: "#e8f1f6",
  fontFamily: "monospace",
  fontWeight: 700,
  color: "#0b6b7a",
};

export const outputCell: React.CSSProperties = {
  ...cellBase,
  background: "#f3f9fb",
  fontFamily: "monospace",
  color: "#333",
};
